const STORY_VIDEO_SELECTOR = '.bastion-story-row__video--autoplay';
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function getStoryVideos(scope = document) {
  const videos = [];

  if (scope instanceof Element && scope.matches(STORY_VIDEO_SELECTOR)) {
    videos.push(scope);
  }

  scope.querySelectorAll(STORY_VIDEO_SELECTOR).forEach((video) => videos.push(video));

  return videos;
}

function updateStoryVideo(videoMedia) {
  const video = videoMedia.querySelector('video');

  if (reducedMotionQuery.matches) {
    videoMedia.removeAttribute('autoplay');
    videoMedia.pause?.();

    if (video) {
      video.pause();
      video.controls = true;
    }

    return;
  }

  videoMedia.setAttribute('autoplay', '');

  if (video) {
    video.controls = false;
  }

  videoMedia.play?.();
}

function updateStoryVideos(scope = document) {
  getStoryVideos(scope).forEach(updateStoryVideo);
}

updateStoryVideos();

customElements.whenDefined('video-media').then(() => updateStoryVideos());

reducedMotionQuery.addEventListener('change', () => updateStoryVideos());

document.addEventListener('media:play', (event) => {
  if (reducedMotionQuery.matches && event.target.matches(STORY_VIDEO_SELECTOR)) {
    requestAnimationFrame(() => updateStoryVideo(event.target));
  }
});

document.addEventListener('shopify:section:load', (event) => {
  updateStoryVideos(event.target);
});
